/** Live rows whose last capture is older than this should not look "current". */
export const STALE_LIVE_SCREENSHOT_MS = 60 * 60 * 1000;

export function isLiveActivityStatus(status: unknown): boolean {
  return status === 'online' || status === 'idle';
}

/**
 * Quiet Last screenshot / Last app cells without hiding the values.
 * Offline and absent stay muted so live activity still pops; the relative
 * time remains visible so a day vs weeks is glanceable.
 */
export function isEmployeesListActivityQuiet(params: {
  status: unknown;
  screenshotAgeMs: number | null;
  expired?: boolean;
}): boolean {
  if (params.expired) {
    return true;
  }
  if (!isLiveActivityStatus(params.status)) {
    return true;
  }
  if (params.screenshotAgeMs == null) {
    return true;
  }
  return params.screenshotAgeMs > STALE_LIVE_SCREENSHOT_MS;
}
